<template>
    <div :class="['s-request-status__form', { 'results-view': resultsView }]">
        <div class="s-request-status__form__row">
            <div class="s-request-status__file-num">
                <div class="input-row">
                    <label for="fileNumberInput">{{ appData.dictionary.fileNumberLabel }}</label>
                    <input
                        id="fileNumberInput"
                        v-model="fileNumber.value"
                        :class="['text-input', { 'input-validation-error': !fileNumber.valid && showValidation }]"
                        type="text"
                        :disabled="resultsView"
                        @input="inputsChanged" />
                    <div class="input-row__error-helper"></div>
                </div>
                <span v-if="!fileNumber.valid && showValidation" class="error-msg field-validation-error">
                    {{ appData.dictionary.requiredField }}
                </span>
            </div>
            <div class="s-request-status__year">
                <select
                    v-model="year.value"
                    :class="['custom-select', { 'input-validation-error': !year.valid && showValidation }]"
                    :disabled="resultsView"
                    @change="inputsChanged">
                    <option v-for="(item, i) in appData.years" :key="'year-' + i" :value="item.value">
                        {{ item.text }}
                    </option>
                </select>
                <span v-if="!year.valid && showValidation" class="error-msg field-validation-error">
                    {{ appData.dictionary.requiredField }}
                </span>
            </div>
        </div>
        <div v-if="!resultsView" class="s-request-status__form__row">
            <div class="s-request-status__request-type">
                <ul class="s-request-status__radio-list">
                    <li v-for="(item, i) in appData.requestTypes" :key="'request-type-' + i">
                        <label :for="'request-type-' + i" class="custom-check">
                            <input
                                :id="'request-type-' + i"
                                v-model="requestType.value"
                                :class="{ 'input-validation-error': !requestType.valid && showValidation }"
                                type="radio"
                                name="file-type"
                                :value="item.value"
                                @change="inputsChanged" />
                            <span class="custom-check__label">
                                {{ item.text }}
                                <span v-if="item.note" class="s-request-status__radio-list__note">{{ item.note }}</span>
                            </span>
                        </label>
                    </li>
                </ul>
                <span v-if="!requestType.valid && showValidation" class="error-msg field-validation-error">
                    {{ appData.dictionary.requiredField }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import * as lib from 'Root/lib/lib.js'
import CustomSelectUI from 'Root/ui/components/CustomSelectUI.js'

export default {
    props: {
        resultsView: {
            type: Boolean,
            default: false,
        },
        showValidation: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['user-data-updated'],

    data() {
        return {
            fileNumber: {
                valid: false,
                value: '',
            },
            year: {
                valid: false,
                value: '',
            },
            requestType: {
                valid: false,
                value: '',
            },
        }
    },

    mounted() {
        this.inputsChanged()

        this.$nextTick(() => {
            this.$el.querySelectorAll('.custom-select').forEach((elem) => {
                elem.CustomSelect = new CustomSelectUI(elem)
            })
        })
    },

    methods: {
        inputsChanged() {
            this.validateInputs()

            this.$emit('user-data-updated', {
                fileNumber: this.fileNumber.value,
                year: this.year.value,
                requestType: this.requestType.value,
            })
        },

        validateInputs() {
            this.fileNumber.valid = lib.hasValue(this.fileNumber.value)
            this.year.valid = lib.hasValue(this.year.value)
            this.requestType.valid = lib.hasValue(this.requestType.value)
        },

        isValid() {
            return this.fileNumber.valid && this.year.valid && this.requestType.valid
        },
    },
}
</script>
